<template>
  <fragment>
    <v-breadcrumbs :items="routesBack">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-container fluid class="mt-10 mx-1">
      <InviteForm />
    </v-container>
  </fragment>
</template>

<script>
import InviteForm from "@/components/marketing/invitation/form/InviteForm.vue";
// eslint-disable-next-line no-unused-vars
import { mapActions, mapGetters } from "vuex";
// eslint-disable-next-line no-unused-vars
import AppBody from "@/layouts/components/AppBody.vue";
export default {
  name: "InviteFormEdit",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    AppBody,
    InviteForm,
  },
  computed: {
    ...mapGetters(["getTypeInvite", "inviteEvent"]),
    showEventInvitePage() {
      if (this.infoEvent !== null) {
        return true;
      }
      return false;
    },
    infoEvent() {
      return JSON.parse(localStorage.getItem("eventoData"));
    },
    returnRoute() {
      if (this.showEventInvitePage === true) {
        return `/marketing/convite/listar/${this.infoEvent?.idproduto}`;
      } else {
        return "/marketing/convite";
      }
    },
    titleModal() {
      return "Editar Convite";
    },
    routesBack() {
      return [
        {
          text: "Convites",
          disabled: false,
          href: this.returnRoute,
        },
        {
          text: this.titleModal,
          disabled: true,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["setTypeInvite"]),
  },
};
</script>
